import { render, staticRenderFns } from "./BillDetailPage.vue?vue&type=template&id=53adeacc&scoped=true"
import script from "./BillDetailPage.vue?vue&type=script&lang=js"
export * from "./BillDetailPage.vue?vue&type=script&lang=js"
import style0 from "./BillDetailPage.vue?vue&type=style&index=0&id=53adeacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53adeacc",
  null
  
)

export default component.exports